<template>
	<div class="h-list" style="width: 800px;margin: 20px auto">
		<div class="h-list-item">
			<div class="h-list-item-meta" v-for="(check,name) in checkList" :key="name">
				<span class="h-list-item-title font-bold">{{ name }}：</span>
				<i v-if="check.loading" class="h-icon-loading"></i>
				<span v-if="check.msg" class="red-color">{{ check.msg }}</span>
				<span v-else>{{ check.loading ? '检查中...' : '已完成' }}</span>
				<Button size="s" @click="calcZcfz()" style="margin-left: 10px" v-if="check.msg == '资产负债表不平衡！'" color="primary">重新计算</Button>
				<Button size="s" @click="finishingOffNo()" style="margin-left: 10px" v-if="check.msg == '凭证号不连续'" color="primary">一键整理断号</Button>
			</div>
		</div>
		<div class="text-center padding">
			<Button :loading="loading" @click="back">上一步</Button>
			<Button color="primary" :loading="loading" @click="invoicing" :disabled="!checked">结 账</Button>
		</div>
	</div>
</template>

<script>
import {mapState} from 'vuex'
import checkout from "@api/checkout";
import voucher from "@api/voucher";//jxd断号整理
import ReportApi from "@/api/report";//资产负债表检测
import {VXETable} from "vxe-table";

export default {
	name: "Check",
	props: {
		checkYear: [Number, String],
		checkMonth: [Number, String],
	},
	data() {
		return {
			loading: false,
			checkList: {
				"期初检查": {
					loading: true
				},
				"期末检查": {
					loading: true
				},
				"报表检查": {
					loading: true
				},
				"断号检查": {
					loading: true
				}
			}
		};
	},
	computed: {
		...mapState(['currentAccountSets']),
		checked() {
			return Object.values(this.checkList).every(value => !value.loading && !value.msg);
		}
	},
	mounted() {
		if (this.currentAccountSets.voucherReviewed) {
			this.checkList['审核检查'] = {
				loading: true
			}
		}
		this.init();
	},
	methods: {
		//jxd重算负债表
		calcZcfz() {
			this.checkList.报表检查.loading = true; // 结束加载状态
			this.checkList.报表检查.msg = null; // 清除错误消息
			this.init();
		},
		//jxd断号整理
		finishingOffNo() {
			voucher.finishingOffNo({year:this.checkYear, month: this.checkMonth}).then(() => {
				this.checkList.断号检查.loading = false; // 结束加载状态
				this.checkList.断号检查.msg = null; // 清除错误消息
				this.init();
			})
		},
		//jxd负债表检测
		zcfzCheck(){
			ReportApi.view('zcfz', {
				voucherDate: this.currentAccountSets.currentAccountDate,
				dimension: 'TERM'
			}).then(({data}) => {
				// jxd 负债表平衡检测
				this.checkList.报表检查.loading = false;
				let totalAssets;
				let liabilitiesAndOwner;
				for(let i =0; i<data.length;i++){
					if(data[i].title == "资产合计"){
						totalAssets = data[i].values;
						//适应工会准则资产负债表
					}else if(data[i].title == "负债和所有者权益（或股东权益）" || data[i].title == "负债与净资产总计"){
						liabilitiesAndOwner = data[i].values;
					}
				}
				//对比判断
				if(totalAssets.年初余额 === liabilitiesAndOwner.年初余额 && totalAssets.期末余额 === liabilitiesAndOwner.期末余额){
				}else{
					//不一致
					this.checkList.报表检查.msg = '资产负债表不平衡！';
				}
			})
		},
		init() {
			checkout.initialCheck({year: this.checkYear, month: this.checkMonth}).catch(() => {
				this.checkList.期初检查.msg = "期初不平衡";
			}).finally(() => {
				this.checkList.期初检查.loading = false;
			});

			checkout.finalCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
				this.checkList.期末检查.loading = false;
			}).catch(() => {
				this.checkList.期末检查.msg = "期末不平衡";
			});

			// checkout.reportCheck({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
			// 	this.checkList.报表检查.loading = false;
			// 	if (data && !data.result) {
			// 		let num = data.资产类 - data.负债类;
			// 		this.checkList.报表检查.msg = `资产负债不平衡，(资产(${data.资产类}) - 负债(${data.负债类}) = ${num} != 权益(${data.权益类}))，差额 ${(num - data.权益类).toFixed(2)}`;
			// 	}
			// });
			//jxd延迟几秒在检测，防止损益凭证的保存还没执行完
			setTimeout(() => {
				console.log({year:this.checkYear, month: this.checkMonth})
				console.log(this.currentAccountSets.currentAccountDate)
				ReportApi.view('zcfz', {
					voucherDate: this.checkYear + "-" + this.checkMonth,
					dimension: 'TERM'
				}).then(({data}) => {
					// jxd 负债表平衡检测
					this.checkList.报表检查.loading = false;
					let totalAssets;
					let liabilitiesAndOwner;
					for(let i =0; i<data.length;i++){
						if(data[i].title == "资产合计" || data[i].title == "资产总计"){
							totalAssets = data[i].values;
							//适应工会准则资产负债表
						}else if(data[i].title == "负债和所有者权益（或股东权益）" || data[i].title == "负债与净资产总计" || data[i].title == "负债和净资产总计" || data[i].title == "负债和净资产合计" || data[i].title == "负债与结余合计"){
							liabilitiesAndOwner = data[i].values;
						}
					}
					//对比判断
					if(VXETable.formats.store.toMoney({cellValue:totalAssets.年初余额}) === VXETable.formats.store.toMoney({cellValue:liabilitiesAndOwner.年初余额}) && VXETable.formats.store.toMoney({cellValue:totalAssets.期末余额}) === VXETable.formats.store.toMoney({cellValue:liabilitiesAndOwner.期末余额})){
					}else{
						//不一致
						this.checkList.报表检查.msg = '资产负债表不平衡！';
					}
				})
			}, 5000);

			checkout.brokenCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
				this.checkList.断号检查.loading = false;
			}).catch(() => {
				this.checkList.断号检查.msg = "凭证号不连续";
			});

			if (this.currentAccountSets.voucherReviewed) {
				checkout.reviewedCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
					this.checkList.审核检查.loading = false;
				}).catch(() => {
					this.checkList.审核检查.msg = "还有凭证未审核";
				});
			}
		},
		invoicing() {
			this.loading = true;
			checkout.invoicing({year: this.checkYear, month: this.checkMonth}).then(() => {
				this.$Message("结转成功！");
				this.$store.dispatch('init');
				this.$emit('success');
				location.reload();//结账成功后，刷新所有页面jxd
			}).finally(() => {
				this.loading = false;
				localStorage.removeItem("voucherDate" + this.currentAccountSets.id);//删凭证日期缓存
			});
		},
		back() {
			this.$emit('back');
		}
	}
};
</script>

<style lang="less" scoped>
.h-list-item-meta {
	margin: 20px;
}
</style>
